import { Component, OnInit } from '@angular/core';
import { ScheduleEventEmitterBo } from './schedule.modal';
@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss']
})
export class ScheduleComponent implements OnInit {
  ScheduleEditList: boolean = false;
  constructor() {
  }
  ngOnInit(): void {

  }
  isListorUpdateView: ScheduleEventEmitterBo = {
    isCreate: false,
    isClose: null,
    ClientDropdown:null,
    CustomFrequencyList:null
  };
  EmitChildComponent(event: ScheduleEventEmitterBo) {
    this.ScheduleEditList = event.isCreate;
    this.isListorUpdateView = event;
  }
}

